export const changePathNameToScreenId = (pathName = window.location.pathname) => {
  const screenId = pathName.replace(/^\/|\/$/g, '').replace(/(\/([a-z]{2})\/)|\//g, '_');

  return screenId || 'log_in';
};
